
const linkUrl = "https://links.mindful.uber5.com/deeplink";

export default linkUrl;
